import { render, staticRenderFns } from "./ViewLprCarplate.vue?vue&type=template&id=a96e6de4&"
import script from "./ViewLprCarplate.vue?vue&type=script&lang=js&"
export * from "./ViewLprCarplate.vue?vue&type=script&lang=js&"
import style0 from "./ViewLprCarplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports